(function ($) {
  'use strict';
  if (!$) return;

  var catalogUrl = '/products.json?limit=250';
  var triggerTag = 'compre1leve2';
  var giftTag = 'segudaunidadetxq';
  var propertyName = '_automatic_bogo_gift';
  var propertyValue = 'replicas-legendary';
  var triggerVariants = {};
  var giftVariantId = null;
  var ready = false;
  var syncing = false;
  var syncAgain = false;

  function getJSON(url) {
    return $.ajax({ url: url, dataType: 'json', cache: false });
  }

  function isGift(item) {
    return item.properties && item.properties[propertyName] === propertyValue;
  }

  function loadPromotion() {
    return getJSON(catalogUrl).then(function (catalogResponse) {
      var products = catalogResponse.products || [];
      var triggerProducts = products.filter(function (product) {
        return (product.tags || []).some(function (tag) {
          return String(tag).trim().toLowerCase() === triggerTag;
        });
      });
      var giftProducts = products.filter(function (product) {
        return (product.tags || []).some(function (tag) {
          return String(tag).trim().toLowerCase() === giftTag;
        });
      });

      triggerProducts.forEach(function (product) {
        (product.variants || []).forEach(function (variant) {
          triggerVariants[String(variant.id)] = true;
        });
      });

      if (giftProducts.length) {
        var rgbVariant = (giftProducts[0].variants || []).filter(function (variant) {
          var titleOptions = String(variant.title).toLowerCase().split(' / ');
          var variantOptions = (variant.options || []).concat([
            variant.option1,
            variant.option2,
            variant.option3
          ]);
          var titleIsRgb = titleOptions.some(function (option) {
            return String(option).trim() === 'rgb';
          });
          var optionIsRgb = variantOptions.some(function (option) {
            return String(option).trim().toLowerCase() === 'rgb';
          });
          return variant.available !== false && (titleIsRgb || optionIsRgb);
        })[0];

        if (rgbVariant) giftVariantId = rgbVariant.id;
      }

      ready = true;
    });
  }

  function refreshCart(cart) {
    if (typeof window.refreshCart === 'function') window.refreshCart(cart);
  }

  function finish() {
    syncing = false;
    if (syncAgain) {
      syncAgain = false;
      syncGift();
    }
  }

  function syncGift() {
    if (!ready || !giftVariantId) return;
    if (syncing) {
      syncAgain = true;
      return;
    }

    syncing = true;
    getJSON('/cart.js').then(function (cart) {
      var hasTrigger = cart.items.some(function (item) {
        return !isGift(item) && triggerVariants[String(item.variant_id)];
      });
      var gift = cart.items.filter(isGift)[0];

      if (hasTrigger && !gift) {
        var properties = {};
        properties[propertyName] = propertyValue;
        return $.ajax({
          url: '/cart/add.js',
          type: 'POST',
          dataType: 'json',
          data: { id: giftVariantId, quantity: 1, properties: properties }
        }).then(function () {
          return getJSON('/cart.js').then(refreshCart);
        });
      }

      if (!hasTrigger && gift) {
        return $.ajax({
          url: '/cart/change.js',
          type: 'POST',
          dataType: 'json',
          data: { id: gift.key, quantity: 0 }
        }).then(refreshCart);
      }

      if (gift && gift.quantity !== 1) {
        return $.ajax({
          url: '/cart/change.js',
          type: 'POST',
          dataType: 'json',
          data: { id: gift.key, quantity: 1 }
        }).then(refreshCart);
      }
    }).always(finish);
  }

  $(function () {
    loadPromotion().then(syncGift);
    $(document).ajaxComplete(function (event, xhr, settings) {
      if (!settings || !settings.url || !/\/cart\/(add|change|update)\.js/.test(settings.url)) return;

      if (syncing) {
        syncAgain = true;
        return;
      }

      window.setTimeout(syncGift, 50);
    });
  });
})(window.jQuery);
